/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Action_DeactivateInputs */

const en_users_action_deactivate = /** @type {(inputs: Users_Action_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate`)
};

const pt_br2_users_action_deactivate = /** @type {(inputs: Users_Action_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar`)
};

/**
* | output |
* | --- |
* | "Deactivate" |
*
* @param {Users_Action_DeactivateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_action_deactivate = /** @type {((inputs?: Users_Action_DeactivateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Action_DeactivateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_action_deactivate(inputs)
	return pt_br2_users_action_deactivate(inputs)
});